import { Customer } from './../../model/customer';
import { Injectable } from '@angular/core';
import { ProxyService } from './proxy.service';
import { OperationResult } from '@tb/auth';

@Injectable({
    providedIn: 'root',
})
export class PrivacyAgreementService {
    public PersonalDataAgreeInt: boolean = false;
    public PersonalDataAgreeExt: boolean = false;
    public DisablePersonalDataAgreeExt = false;
    public UserID: string = '';

    constructor(private proxyService: ProxyService) {}

    public async setAgreementFlag() {
        if (this.UserID.length == 0) {
            this.PersonalDataAgreeExt = false;
            this.PersonalDataAgreeInt = false;
            return;
        }

        let opResult: OperationResult = await this.proxyService.getEndUserInformation(this.UserID);
        if (opResult.Result) {
            let endUserMaster: Customer = opResult.Content as Customer;
            this.PersonalDataAgreeExt = endUserMaster.PersonalDataAgreeExt;
            this.PersonalDataAgreeInt = endUserMaster.PersonalDataAgreeInt;
            this.DisablePersonalDataAgreeExt = this.PersonalDataAgreeExt;
        } else {
            this.PersonalDataAgreeExt = false;
            this.PersonalDataAgreeInt = false;
        }
    }
    clear() {
        this.PersonalDataAgreeInt = false;
        this.PersonalDataAgreeExt = false;
    }
}
